import { fetchApp, fetchApps } from '@/services/app'
import { App } from '@/services/types'
import { getApp, setApp, unsetApp } from '@/utils/app'
import { fetchPosts } from '@/services/posts'
import { Commit } from 'vuex'
import { AppActions } from './types'

const initApp = async (appId: number, commit: Commit): Promise<void> => {
  const [app, posts] = await Promise.all([fetchApp(appId), fetchPosts({ appId })])

  commit('setSelectedAppPosts', posts)
  commit('setSelectedApp', app)
  setApp(app)
}

const actions: AppActions = {
  async fetchApps({ commit }): Promise<void> {
    const apps = await fetchApps()
    const localApp = getApp()

    commit('setApps', apps)

    if (localApp) {
      try {
        await initApp(localApp.id, commit)
      } catch (e) {
        if (apps[0]) {
          await initApp(apps[0].id, commit)
        }
      }
    } else if (apps[0]) {
      await initApp(apps[0].id, commit)
    }
  },
  async selectApp({ commit }, app: App): Promise<void> {
    commit('setSelectedAppPosts', await fetchPosts({ appId: app.id }))
    setApp(app)
    commit('setSelectedApp', app)
  },
  async unsetApps({ commit }): Promise<void> {
    commit('setSelectedAppPosts', [])
    commit('setApps', null)
    commit('setSelectedApp', null)

    unsetApp()
  },
  changeVisibilityMenu({commit}, value: boolean): void {
    commit('setVisibilityMenu', value)
  }
}

export default actions
